import React, { Component } from 'react';
import { Card, Column } from './styled/CallContinuedMessageStyled';
import Icon from '../Icon';
import Row from '../Row';

interface LocalizationLike {
    getText: (key: string) => string;
}
interface Props {
    localization: LocalizationLike;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class CallContinuedMessage extends Component<Props> {
    render() {
        const { localization } = this.props;
        return (
            <Card className="message">
                <Column $marginRight={30}>
                    <Icon name="PhoneForwarded" />
                </Column>
                <Column>
                    <Row>{localization.getText('trainer.call_messages.sound_continued')}</Row>
                </Column>
            </Card>
        );
    }
}
